<template>

	<div>
		<NavMenu/>
		<div class="zjWarp">
			<div class="newsSecondPage4">
				<div class="rightMore">
					<div>注：排名按照首字母排序</div>
					<div class="search-box">
						<!-- <input type="text" v-model="msg"> -->
						<el-input type="text" v-model="searchVal" placeholder="请输入姓名" @keydown.enter.native="serchEnterFn" class="input-with-select">
						</el-input>
						<img src='@/assets/imgs/home/searchicon.png' @click.stop="serchEnterFn" />
					</div>
				</div>
				<div class="newsbox" v-if="dataList.length!==0">
					<div class="infoDataBox">
						<div v-for="(item,index) in dataList" :key="index" class="itemBox" @click="showDetailFn(item)">
							<div class="leftbox">
								<img :src="srcUrl+item.expertPicture" class="imgbox" />
								<div class="namebox">
									<div class="name">{{item.expertName}}</div>
								</div>
							</div>
							<div class="rightbox">
								<div class="infoText">
									<div class="title">专家类别</div>
									<div class="fh">：</div>
									<div class="texte overflowone">{{item.dictionariesId==358?item.otherInfo:item.expertType}}</div>
								</div>
								<div class="infoText">
									<div class="title">所在单位</div>
									<div class="fh">：</div>
									<div class="texte">{{item.unit}}</div>
								</div>
								<div class="infoText">
									<div class="title">职务</div>
									<div class="fh">：</div>
									<div class="texte">{{item.duty}}</div>
								</div>
								<div class="infoText2">
									<div class="title2">
										<div class="title">个人简介</div>
										<div class="fh">：</div>
									</div>
									<div class="texte overflowfour">{{item.synopsis}}</div>
								</div>

							</div>
						</div>
					</div>
					<div class="pagination-box">
						<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
						    :page-sizes="[4, 6, 8]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
						</el-pagination>
					</div>
				</div>
				<div class="emptyBox" v-else>
					<img src="@/assets/imgs/home/emptyimg.png" />
				</div>
				<!-- 详情 -->
				<el-dialog title="" :visible.sync="detailVisible" width="800px" class="dialogWarp" :destroy-on-close="true" :close-on-click-modal='false'
				    :append-to-body="true">
					<div class="zjdialogcenter" v-if="currentData">
						<div class="titleName">专家详情</div>
						<!-- {{currentData}} -->
						<div class="seoncdbox">
							<div class="infoText">
								<div class="title">专家类别</div>
								<div class="fh">：</div>
								<div class="texte">{{currentData.dictionariesId==358?currentData.otherInfo:currentData.expertType}}</div>
							</div>
							<div class="infoText">
								<div class="title">所在单位</div>
								<div class="fh">：</div>
								<div class="texte">{{currentData.unit}}</div>
							</div>
							<div class="infoText">
								<div class="title">职务</div>
								<div class="fh">：</div>
								<div class="texte">{{currentData.duty}}</div>
							</div>
						</div>
						<div class="botBox">
							<div class="leftbox">
								<img :src="srcUrl+currentData.expertPicture" class="imgbox" />
								<div class="namebox">
									<div class="name">{{currentData.expertName}}</div>
								</div>
							</div>
							<div class="infoText2">
								<div class="title2">
									<div class="title">个人简介</div>
								</div>
								<div class="texte">{{currentData.synopsis}}</div>
							</div>

						</div>

						<!-- {{currentRemark?currentRemark:'暂无简介~'}} -->
					</div>
					<span slot="footer" class="dialog-footer">
						<el-button @click="closeFn">关 闭</el-button>
					</span>
				</el-dialog>
			</div>
		</div>
		<div class="footerbox">
			<Footer/>
		</div>
	</div>
</template>
<script>
import NavMenu from '@/components/navMenu.vue'
import Footer from '@/components/footer.vue'
import { httpService, srcUrl } from "@/service/httpService";
export default {
	components: {
		NavMenu,
		Footer,
	},
	data() {
		return {
			srcUrl: srcUrl,
			currentPage: 1,
			total: 10,
			pageSize: 4,
			dataList: [],
			searchVal: null,//搜索字段
			detailVisible: false,
			currentData: null,

		}
	},
	watch: {
		$route: {
			handler: function (val, oldVal) {
				let currentNew = JSON.parse(sessionStorage.getItem('currentNew'))
				if (currentNew) {
					if (currentNew.currentPage) {
						this.currentPage = currentNew.currentPage * 1;
						// this.getNews();
					}
					if (currentNew.site) {
						document.body.scrollTop = currentNew.site
					}
				}
				sessionStorage.removeItem('currentNew')
			},
			deep: true,
			immediate: true,
		},
	},
	mounted() {
		this.getNews()
	},
	methods: {
		serchEnterFn() {
			this.getNews()
		},
		async getNews() {
			let params = {
				pageSize: this.pageSize,
				pageCurrent: this.currentPage,
				audit: 2,
				findAll: this.searchVal
			};
			let data = await httpService.beforestageExpertList(params);
			if (data.code == 200) {
				this.dataList = data.result.list
				this.total = data.result.total;
			}
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.currentPage = 1;
			this.getNews();
		},
		handleCurrentChange(val) {
			// this.pageSize = 1;
			this.currentPage = val;
			this.getNews();
		},
		// goNewsDetailFn(val) {
		//     let currentNew = {
		//         menuurl: '/industry-secondpage/experts-think',
		//         currentPage: this.currentPage,
		//         site: window.scrollY,
		//         title: '专家库'
		//     }
		//     sessionStorage.setItem('currentNew', JSON.stringify(currentNew))
		//     this.$router.push({
		//         path: "/news-detail",
		//         query: {
		//             id: val.pressId,
		//         },
		//     });
		// }
		showDetailFn(item) {
			this.detailVisible = true;
			this.stopScroll()
			this.currentData = item
		},
		closeFn() {
			this.detailVisible = false;
			this.canScroll()
		}


	},
	filters: {
		timer: (value) => {
			return value.substring(0, 10);
		},
	},
}
</script>
<style lang="less" scoped>
.zjWarp {
	padding: 50px 0 0 0;
}
.newsSecondPage4 {
	width: 1200px;
	margin: 0 auto;
	padding-bottom: 20px;
	.rightMore {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		align-content: center;
		margin: 0 10px 16px 0;
		font-size: 14px;
		color: #999999;
		.search-box {
			// background: #1088fe;
			width: 266px;
			justify-content: center;
			align-items: center;
			align-content: center;
			text-align: center;
			// padding: 30px 0px;
			height: 40px;
			display: flex;
			flex-direction: row;
			// margin-right: 32px;
			position: relative;
			/deep/.el-input__inner {
				// background-color: #68b4ff;
				border: 1px solid #cacaca;
				color: #000 !important;
				border-radius: 20px;
			}
			/deep/input::placeholder {
				color: #cacaca !important;
			}
			img {
				position: absolute;
				// height: 40px;
				// width: 40px;
				right: 5px;
				cursor: pointer;
			}
		}
		.morebox {
			margin-top: 0;
		}
	}
	.newsbox {
		// max-height: 860px;
		min-height: 660px;
		position: relative;
		.pagination-box {
			position: absolute;
			bottom: -70px;
			left: 50%;
			transform: translateX(-50%);
		}
		.infoDataBox {
			display: flex;
			flex-direction: row;
			flex-wrap: wrap;
			.itemBox {
				display: flex;
				flex-direction: row;
				margin: 0 44px 36px 0;
				width: 47.5%;
				cursor: pointer;
				box-shadow: 0px 10px 25px 1px rgba(0, 0, 0, 0.03);
				border-radius: 10px 10px 10px 10px;
				border: 1px solid #e8e8e8;
				&:nth-child(2n) {
					margin-right: 0;
				}
				.leftbox {
					width: 39%;
					height: 286px;
					display: flex;
					flex-direction: row;
					position: relative;
					.imgbox {
						width: 100%;
						// height: 304px;
						border-radius: 10px 0px 0px 10px;
					}
					.namebox {
						position: absolute;
						bottom: 0;
						z-index: 99;
						height: 48px;
						line-height: 48px;
						background: linear-gradient(180deg, #4d99ff 0%, #1d5dd6 100%);
						width: 100%;
						font-size: 20px;
						font-family: Source Han Sans CN-Medium, Source Han Sans CN;
						font-weight: 500;
						color: #ffffff;
						display: flex;
						justify-content: center;

						.name {
							min-width: 60px;
							text-align: justify;
							text-align-last: justify;
							/*兼容ie*/
							text-justify: distribute-all-lines;
						}
					}
				}
				.rightbox {
					width: 61%;
					padding: 20px 20px 0px 16px;
					box-sizing: border-box;
					.infoText {
						display: flex;
						flex-direction: row;
						margin-bottom: 14px;
						font-size: 14px;
						align-content: center;
						align-items: center;

						.title {
							width: 57.5px;
							font-weight: bold;
							color: #313131;
							text-align: justify;
							text-align-last: justify;
							/*兼容ie*/
							text-justify: distribute-all-lines;
						}
						.fh {
							color: #999999;
						}
						.texte {
							color: #666666;
							font-size: 14px;
							width: 242px;
						}
					}
					.infoText2 {
						display: flex;
						flex-direction: column;
						font-size: 16px;
						.title2 {
							display: flex;
							flex-direction: row;
							margin-bottom: 10px;
						}
						.title {
							width: 57.5px;
							font-size: 14px;
							font-weight: bold;
							color: #313131;
							text-align: justify;
							text-align-last: justify;
							/*兼容ie*/
							text-justify: distribute-all-lines;
						}
						.fh {
							color: #999999;
						}
						.texte {
							color: #666666;
							line-height: 28px;
							font-size: 14px;
						}
					}
				}
			}
		}
	}
}
.dialogWarp {
	/deep/.zjdialogcenter {
		padding: 0 16px;
		.titleName {
			font-size: 22px;
			font-family: Source Han Sans CN, Source Han Sans CN;
			font-weight: bold;
			color: #333333;
			line-height: 32px;
			text-align: center;
		}
		.seoncdbox {
			display: flex;
			flex-direction: row;
			justify-content: center;
			margin: 24px 0;
			flex-wrap: wrap;
			.infoText {
				display: flex;
				flex-direction: row;
				align-content: center;
				align-items: center;
				font-size: 16px;
				.title {
					// width: 68px;
					font-weight: bold;
					color: #313131;
					font-size: 14px;
					// text-align: justify;
					// text-align-last: justify;
					// /*兼容ie*/
					// text-justify: distribute-all-lines;
					margin-left: 12px;
				}
				.fh {
					color: #999999;
				}
				.texte {
					color: #666666;
					padding: 0 12px 0 0px;
					border-right: 1px solid rgba(112, 112, 112, 0.2);
					font-size: 14px;
				}
				&:last-child {
					.texte {
						border: none;
					}
				}
				&:first-child {
					.title {
						margin: 0px;
					}
				}
			}
		}

		.botBox {
			// display: flex;
			// flex-direction: row;
			min-height: 240px;
			.leftbox {
				// width: 25%;
				width: 162px;
				height: 210px;
				display: flex;
				flex-direction: row;
				position: relative;
				margin-right: 12px;
				// width: 100%;
				overflow: hidden;
				// border: 2px solid #f0f0f0;
				float: left;
				.imgbox {
					width: 100%;
					height: 100%;
					border-radius: 10px 10px 0px 0px;
				}
				.namebox {
					position: absolute;
					bottom: 0;
					z-index: 99;
					height: 40px;
					line-height: 40px;
					background: linear-gradient(180deg, #4d99ff 0%, #1d5dd6 100%);
					width: 100%;
					font-size: 20px;
					font-family: Source Han Sans CN-Medium, Source Han Sans CN;
					font-weight: 500;
					color: #ffffff;
					display: flex;
					justify-content: center;

					.name {
						// width: 76px;
						min-width: 60px;
						text-align: justify;
						text-align-last: justify;
						/*兼容ie*/
						text-justify: distribute-all-lines;
					}
				}
			}
			.infoText2 {
				//     width: 75%;
				// 	display: flex;
				// 	flex-direction: column;
				font-size: 16px;
				.title2 {
					margin-bottom: 10px;
				}
				.title {
					// width: 66px;
					// color: #999999;
					font-weight: bold;
					color: #313131;
					font-size: 14px;
				}
				// 	.fh {
				// 		color: #999999;
				// 	}
				.texte {
					color: #666666;
					line-height: 28px;
					font-size: 14px;
					text-indent: 28px;
					//  letter-spacing:28px;
				}
			}
		}
	}
}
</style>


